import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BookingService {
  private bookingDetails = new BehaviorSubject<any>({});
  getBookingDetails = this.bookingDetails.asObservable();

  private reInitBookingPageOrders$ = new Subject<any>();

  constructor() {
  }

  
  setValues(details: any): void {
    const currentValue = this.bookingDetails.value;
    const updatedValue = {...currentValue, ...details};
    this.bookingDetails.next(updatedValue);
  }

  reInitBookingPageOrdersObservable(): Observable<any> {
    return this.reInitBookingPageOrders$.asObservable();
  }

  reInitBookingPageOrders(): void {
    this.reInitBookingPageOrders$.next(true);
  }


}
